import { type FC } from "react"

import { cn } from "@forento/ui/utilities/tailwind"

type Props = {
	count: number
	limit: number
	className?: string
}

const CharacterCounter: FC<Props> = ({ count, limit, className }) => {
	const ratio = limit === 0 ? 0 : count / limit
	const isAtLimit = limit > 0 && count >= limit
	const tone = isAtLimit ? "text-red-600" : ratio >= 0.75 ? "text-amber-600" : "text-emerald-600"

	return (
		<div className={cn("mt-1.5 text-right text-xs font-medium", tone, className)} aria-live="polite">
			{count}/{limit}
		</div>
	)
}

export default CharacterCounter
